import {Pipe, PipeTransform} from '@angular/core';
import {PricePipe} from './price.pipe';
import {PriceDisplayService} from '../services/core/price-display.service';

/**
 * Price of a product (gross in cent, tax rate): corporate customers see the net price with " netto",
 * all others the gross price without label. Usage: {{ product.PriceGross | NetPrice: product.Tax }}
 * label false: only the value (e.g. when "netto" stands elsewhere).
 * Not pure: changes with the login of a corporate customer.
 */
@Pipe({
  name: 'NetPrice',
  pure: false
})
export class NetPricePipe implements PipeTransform {
  constructor(
    private pricePipe: PricePipe,
    private priceDisplayService: PriceDisplayService
  ) {
  }

  transform(gross: number, tax: number, label: boolean = true, decimals: number = 2, placeholder: string = null): string {
    if (gross == null) {
      return placeholder;
    }
    const displayed = this.priceDisplayService.getDisplayed(gross, tax);
    const price = this.pricePipe.transform(displayed.Value, decimals, placeholder);
    return displayed.Net && label ? price + ' netto' : price;
  }
}
